module.exports = "/*\r\n.header {\r\n  padding: 10px;\r\n  background-color: rgb(163, 163, 163);\r\n  color: #FFF;\r\n}\r\nul, li {\r\n  list-style: none;\r\n  display: inline;\r\n  padding: 10px;\r\n}\r\n*/\r\n.logo-topo {\r\n  height: 30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = ./src/app/header/header.component.css
// module chunks = main